import { render } from "./BeliefsPage.vue?vue&type=template&id=d4e132d4&scoped=true"
import script from "./BeliefsPage.vue?vue&type=script&lang=js"
export * from "./BeliefsPage.vue?vue&type=script&lang=js"

import "./BeliefsPage.vue?vue&type=style&index=0&id=d4e132d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e132d4"]])

export default __exports__